// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabTitleSVG_tab__1WqZ5","activeTab":"TabTitleSVG_activeTab__1mSDj","activeTitle":"TabTitleSVG_activeTitle__2Xmw6"};